import { connect } from 'react-redux';
import actions from '../redux/actions/transactions';
import TransactionHistory from '../component/TransactionHistory';

const mapStateToProps = (state) => ({
  trans: state.transaction.trans,
  // settings: state.settings,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchTransactionFilterHistory: (params, callback) => {
    dispatch(actions.onFetchTransactionFilterHistory(params, callback));
  },
  searchTransByIDAction: (params, callback) => {
    dispatch(actions.searchTransByIDAction(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionHistory);
